export const errorNumberToErrorFormatMapping = {
  ErrorNumber_44003: { isHtmlMessage: true },
};
